import React from 'react';

/**
 * React Error Boundary — перехватывает необработанные ошибки в дереве компонентов
 * и показывает fallback UI вместо пустого экрана.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            padding: '24px',
            backgroundColor: 'var(--bg-primary, #f5f5f5)',
            color: 'var(--text-primary, #212529)',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}
        >
          <h1 style={{ marginBottom: '16px', fontSize: '1.5rem' }}>
            Произошла непредвиденная ошибка
          </h1>
          <p
            style={{
              marginBottom: '24px',
              maxWidth: '400px',
              textAlign: 'center',
              color: 'var(--text-muted, #6c757d)'
            }}
          >
            Приложение столкнулось с ошибкой. Попробуйте перезагрузить страницу.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            Перезагрузить страницу
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
